import { animated } from "react-spring";
import { useEntity, useFlow } from "student-front-commons/src/hooks";
import { START_ITEM_INTRODUCTION_FLOW } from "../../consts";
import { useSelector } from "react-redux";
import { getInstructionStep } from "student-front-commons/src/selectors/itemInstruction";
import { getCurrentItemExecutionProp } from "student-front-commons/src/selectors/itemExecution";
import { get, head } from "lodash";
import React, { useMemo } from "react";
import { PROFILE_SCHEMA } from "student-front-commons/src/schemas";
import locales from "../../locales";

const instructionTypeMapping = {
  initial: "INITIAL",
  repeat: "REPEAT",
  record: "RECORD",
  listen: "LISTEN",
  reading: "READ",
  next: "NEXT",
  translate: "TRANSLATE",
  "speech-recognition-result": "SPEECH_RECOGNITION_RESULT",
};

export default function ItemInstructionText() {
  const [isRunning] = useFlow(START_ITEM_INTRODUCTION_FLOW);

  const instructionStep = useSelector(getInstructionStep);
  const itemType = useSelector(getCurrentItemExecutionProp("item.type"));

  const profile = useEntity(PROFILE_SCHEMA, sessionStorage.getItem("id"));

  const stepText = useMemo(() => {
    const instructions = get(itemType, "instructions", []).filter(
      (instruction) => instruction.type === instructionTypeMapping[instructionStep]
    );
    const instruction = instructions.find(
      (instruction) => head(instruction.locale.split("-")) === locales.getLanguage()
    );
    if (instruction) {
      return instruction.text;
    }
  }, [itemType?.key, profile?.locale, instructionStep]);

  if (!isRunning || !stepText) return null;

  return (
    <animated.div
      style={{
        left: 0,
        width: "100%",
        display: "flex",
        position: "fixed",
        justifyContent: "center",
        alignItems: "center",
        userSelect: "none",
        zIndex: 12,
        transition: "opacity .3s ease, bottom .3s ease, width .3s ease",
        opacity: isRunning ? 1 : 0,
        bottom: isRunning ? 110 : -100,
      }}
    >
      <p
        style={{
          color: "#424242",
          textAlign: "center",
          maxWidth: 980,
          fontSize: 14,
          margin: 0,
          padding: "10px 12px",
          backgroundColor: "#fff",
          borderRadius: 4,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 3px 3px 0px",
        }}
      >
        {stepText}
      </p>
    </animated.div>
  );
}
